/** @format */

import { Button, Col, Collapse, Row, Spin, Grid } from "antd";
import { MinusCircleOutlined, PlusCircleOutlined } from "@ant-design/icons";
import axios from "axios";
import Link from "next/link";
import { useEffect, useState } from "react";
import type { Articles } from "../../../interfaces/articles";
import responsiveColumn from "../../../methods/responsiveColumn";

export default function FrequentlyAskedQuestions() {
	const { useBreakpoint } = Grid;
	const screenSize = useBreakpoint();
	const [faqs, setFaqs] = useState<Articles>();
	const fetchFAQS = async () => {
		try {
			const r = await axios({
				url: "https://wp.taxworkoutgroup.com/wp-json/wp/v2/faqs?_embed&per_page=100",
				method: "get",
			});

			setFaqs(r.data);
		} catch (e) {
			console.log(e);
		}
	};
	useEffect(() => {
		fetchFAQS();
	}, []);

	return (
		<Row style={{ padding: "50px 0px" }} gutter={[20, 20]}>
			<Col span={24}>
				<Row justify={"center"}>
					<Col
						{...responsiveColumn([12, 12, 12, 22, 22, 22])}
						style={{ textAlign: "center", lineHeight: 1.5 }}>
						<h2
							className='section_title'
							style={{
								// fontSize:screenSize.lg 48
								fontSize: screenSize.md ? 48 : 30,
							}}>
							Frequently Asked Questions
						</h2>
					</Col>
				</Row>
				<Row justify={"center"} style={{ padding: "0px 0 40px 0" }}>
					<Col {...responsiveColumn([18, 19, 20, 22, 22, 22])}>
						<Spin spinning={!faqs ? true : false}>
							<Collapse
								expandIconPosition='end'
								style={{ border: "none" }}
								expandIcon={({ isActive }) =>
									isActive ? (
										<MinusCircleOutlined
											style={{
												fontSize: 20,
											}}
										/>
									) : (
										<PlusCircleOutlined
											style={{
												fontSize: 20,
											}}
										/>
									)
								}>
								{faqs
									?.filter((e) => e.tags.includes(24))
									?.reverse()
									.map((e) => {
										return (
											<Collapse.Panel
												key={e.id}
												header={e.title.rendered}
												style={{
													backgroundColor: "white",
													border: "none",
													padding: "10px 0",
												}}>
												<p
													dangerouslySetInnerHTML={{
														__html: e.content.rendered ?? "",
													}}
													style={{ overflow: "hidden", width: "100%" }}></p>
											</Collapse.Panel>
										);
									})}
							</Collapse>
						</Spin>
					</Col>
				</Row>
				<Row justify={"center"}>
					<Col>
						<Link href='/faqs'>
							<Button
								size='large'
								type='primary'
								style={{ fontSize: 15, padding: "0 30px" }}>
								View More FAQs
							</Button>
						</Link>
					</Col>
				</Row>
			</Col>
		</Row>
	);
}
